export const WA_SESSION_DURATION_MS = 1000 * 60 * 60 * 24; // 24 hours
